<template>
  <v-container class="mt-0 pt-0" :style="MobileSize ? 'padding: 0px !important;' : ''" loading="lazy" id="app">
    <v-carousel
      cycle
      height="100%"
      hide-delimiter-background
      show-arrows-on-hover
      :style="MobileSize ? 'margin-top:10px' : 'margin-top:10px'"
      :class="MobileSize ? 'pa-0' : 'pa-0 rounded-lg'"
    >
      <v-carousel-item
        v-for="(slide, i) in slides"
        :key="i"
        @click="link(slide.link)"
      >
        <v-img v-lazyload loading='lazy' :src="slide.img" height="100%" width="100%" :lazy-src="slide.lazy" contain></v-img>
      </v-carousel-item>
    </v-carousel>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      slides: [
        { img: require('@/assets/ImageINET-Marketplace/Banner/rsz_e-factoring-1.jpg'), link: 'https://factoring.one.th/', lazy: '@/assets/ImageINET-Marketplace/Banner/rsz_e-factoring-1.jpg' },
        { img: require('@/assets/ImageINET-Marketplace/Banner/rsz_2banner01.jpg'), link: '', lazy: '@/assets/ImageINET-Marketplace/Banner/rsz_banner01.jpg' },
        { img: require('@/assets/ImageINET-Marketplace/Banner/rsz_1banner2.jpg'), link: '', lazy: '@/assets/ImageINET-Marketplace/Banner/rsz_banner2.jpg' }
      ]
    }
  },
  computed: {
    main () {
      return this.$route.name === 'HomeProduct'
    },
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  methods: {
    link (val) {
      if (val !== '') {
        window.open(`${val}`)
      }
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 1250px;
}
</style>
